import React from 'react';
import Page404 from '../user/Auth/Page404';
import WarningPage from './WarningPage';
import WarningLoading from './WarningLoading';
import useConfigAccess from './useConfigAccess';
import ConfigScreenContext from './ConfigScreenContext';

// Guards a threshold / config page (see DashboardRouter.js). Replaces the Finance-only FinanceRoute on those pages: Finance still
// opens everything, and a person Finance has given access to a threshold opens that threshold's screen (`config` is the screen's address
// segment, e.g. 'lcr-config'). The server refuses everything else on every config endpoint (requireConfigAccess) - this stops a typed or
// bookmarked address from even loading the page. Waits for the one my-view answer (remembered, so instant after the landing page). It also
// tells WarningPage which threshold this is, for the "Who can set this" line.
const ConfigRoute = ({ config, children }) => {
  const { ready, canConfigure } = useConfigAccess();
  if (!ready) {
    return (
      <WarningPage title="Thresholds">
        <WarningLoading />
      </WarningPage>
    );
  }
  if (canConfigure(config)) return <ConfigScreenContext.Provider value={{ config }}>{children}</ConfigScreenContext.Provider>;
  return <Page404 message="Sorry!! You don'nt have the permission for such an action" />;
};

export default ConfigRoute;
